// 埋点
// code 参数
// 访客触发日志：1000
// 用户点击日志：1001
// 用户发起会话日志：1002
// 用户AI会话结束：1004
// 工单日志：1005

// type 参数
// 用户点击日志：1：热点问题 2：轮播图 3：问题类型 4：我的单据 5：联系客服
// 用户发起会话日志：1：联系客服（首页）2：问答FAQ（热点问题）3：问答FAQ（问题类型）4：人工转AI客服
// 用户AI会话结束：1转人工 2玩家退3转工单 4其他
// 工单日志：1 AI唤起（进入） 2 AI唤起（提交） 3问题分类（进入）4问题分类（提交）
import API from '../../api/question'

// 获取url参数
// const getUrlParam = (name) => {
//   const url = window.location.href
//     const address = url.split('?');
//     if(address[0] === url){ return '';}
//     const arr = address[1].split('&'),len = arr.length;
//     const obj ={};
//     for (var i = 0;i<len;i++){
//         const ads = arr[i].split('=');
//         obj[ads[0]] = ads[1];
//     }
//     return obj[name] || '';
// }
// 获取talkId
const guid = () => {
  return 'xxxxxxxx-xxxx-6xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}
// 只在页面进入时执行一次
const talkId = guid();
// let visitorMd5Code = getUrlParam('v')
let visitorMd5Code = sessionStorage.getItem('md5')
// const Points = class {
//   constructor() {
//     // super()
//   }
//   initPage(params) {
//     console.log(id)
//     console.log(params, 123456)
//   }
// }

const point = (params) => {
  if (!visitorMd5Code) {
    visitorMd5Code = sessionStorage.getItem('md5')
  }
  API.logPoint({ visitorMd5Code, talkId, ...params }, () => {
    console.log('埋点成功')
  })
}
export default {
  talkId,
  point
}



// WEBPACK FOOTER //
// ./src/assets/js/buryingPoint.js